function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (obj) { return typeof obj; }; } else { _typeof = function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep, isPlainObject } from '@cloud-sn/v-utils';
import { addMonths, isSameMonth, isSameDay, isSameHour, isSameMinute, isBefore, isAfter, isEqual, getHours, getMinutes, getSeconds } from 'date-fns';
import { VTimePickerPanel } from '@cloud-sn/v-timepicker';
import { noop, isValidArray, formatDate, isAllowedDate, getTimeConfig, syncTime } from './utils';
import CalendarPart from './rangeCalendar/calendarPart.js';
import TodayButton from './calendar/todayButton.js';
import TimePickerButton from './calendar/timePickerButton.js';
import OkButton from './calendar/okButton.js';

function genEndDisabledTime(start, end, cfg) {
  var nCfg = cfg;

  if (end && isSameDay(start, end)) {
    var _ref = [getHours(start), getMinutes(start), getSeconds(start)],
        sHour = _ref[0],
        sMinute = _ref[1],
        sSecond = _ref[2];
    var _ref2 = [getHours(end), getMinutes(end)],
        eHour = _ref2[0],
        eMinute = _ref2[1];
    var hours = new Set(cfg.disabledHours());

    for (var i = 0; i < sHour; i += 1) {
      hours.add(i);
    }

    var minutes = new Set(cfg.disabledMinutes(eHour));

    if (isSameHour(start, end)) {
      for (var _i = 0; _i < sMinute; _i += 1) {
        minutes.add(_i);
      }
    }

    var seconds = new Set(cfg.disabledSeconds(eHour, eMinute));

    if (isSameMinute(start, end)) {
      for (var _i2 = 0; _i2 < sSecond; _i2 += 1) {
        seconds.add(_i2);
      }
    }

    nCfg = {
      disabledHours: function disabledHours() {
        return Array.from(hours);
      },
      disabledMinutes: function disabledMinutes() {
        return Array.from(minutes);
      },
      disabledSeconds: function disabledSeconds() {
        return Array.from(seconds);
      }
    };
  }

  return nCfg;
}

var __vue_script__ = {
  name: 'RangeCalendar',
  components: {
    CalendarPart: CalendarPart,
    TimePickerPanel: VTimePickerPanel,
    TodayButton: TodayButton,
    TimePickerButton: TimePickerButton,
    OkButton: OkButton
  },
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      required: true,
      validator: function validator(val) {
        return val.every(function (v) {
          return v instanceof Date;
        });
      }
    },
    selectedValue: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(val) {
        return val.every(function (v) {
          return v instanceof Date;
        });
      }
    },
    showClear: Boolean,
    locale: Object,
    mode: {
      type: Array,
      default: function _default() {
        return ['date', 'date'];
      },
      required: true,
      validator: function validator(val) {
        return val.every(function (v) {
          return ['date', 'month', 'year', 'decade'].indexOf(v) !== -1;
        });
      }
    },
    showOk: Boolean,
    showToday: Boolean,
    format: String,
    disabledTime: {
      type: Function,
      default: noop
    },
    disabledDate: {
      type: Function,
      default: noop
    },
    dateInputPlaceholder: [String, Array],
    hasTimePicker: Boolean,
    ranges: {
      type: [Object, Array],
      default: undefined
    },
    showTime: {
      type: [Boolean, Object],
      default: false
    },
    controlMode: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerMode: [],
      hoverValues: [],
      innerValues: [],
      isTimePicker: false,
      firstSelectedVal: null
    };
  },
  computed: {
    isSelectedValue: function isSelectedValue() {
      var selectedValue = this.selectedValue;
      return selectedValue[0] && selectedValue[1];
    },
    isShowClear: function isShowClear() {
      var showClear = this.showClear,
          selectedValue = this.selectedValue;
      return showClear && selectedValue[0] && selectedValue[1];
    },
    isShowOk: function isShowOk() {
      var showOk = this.showOk,
          hasTimePicker = this.hasTimePicker;
      return showOk === true || showOk !== false && !!hasTimePicker;
    },
    isTodayInView: function isTodayInView() {
      var _this$innerValues = _slicedToArray(this.innerValues, 2),
          start = _this$innerValues[0],
          end = _this$innerValues[1];

      var today = new Date();
      return isSameMonth(today, start) || isSameMonth(today, end);
    },
    isTimePickerDisabled: function isTimePickerDisabled() {
      var isSelectedValue = this.isSelectedValue,
          hoverValues = this.hoverValues;
      return !isSelectedValue || hoverValues.length > 0;
    },
    isOkDisabled: function isOkDisabled() {
      var isAllowedDateAndTime = this.isAllowedDateAndTime,
          isTimePickerDisabled = this.isTimePickerDisabled,
          selectedValue = this.selectedValue;
      return isTimePickerDisabled || !isAllowedDateAndTime(selectedValue);
    },
    classes: function classes() {
      var _ref3;

      var prefixCls = this.prefixCls,
          isTimePicker = this.isTimePicker,
          isRanges = this.isRanges;
      return _ref3 = {}, _defineProperty(_ref3, prefixCls, true), _defineProperty(_ref3, "".concat(prefixCls, "-range"), true), _defineProperty(_ref3, "".concat(prefixCls, "-range-with-ranges"), isRanges), _defineProperty(_ref3, "".concat(prefixCls, "-show-time-picker"), isTimePicker), _ref3;
    },
    footerClasses: function footerClasses() {
      var _ref4;

      var prefixCls = this.prefixCls,
          isShowOk = this.isShowOk;
      return _ref4 = {}, _defineProperty(_ref4, "".concat(prefixCls, "-footer"), true), _defineProperty(_ref4, "".concat(prefixCls, "-range-bottom"), true), _defineProperty(_ref4, "".concat(prefixCls, "-footer-show-ok"), isShowOk), _ref4;
    },
    placeholders: function placeholders() {
      var dateInputPlaceholder = this.dateInputPlaceholder;
      var holders = ['', ''];

      if (dateInputPlaceholder) {
        if (Array.isArray(dateInputPlaceholder)) {
          holders = dateInputPlaceholder;
        } else {
          holders = [dateInputPlaceholder, dateInputPlaceholder];
        }
      }

      return holders;
    },
    startPlaceholder: function startPlaceholder() {
      var placeholders = this.placeholders;
      return placeholders[0];
    },
    endPlaceholder: function endPlaceholder() {
      var placeholders = this.placeholders;
      return placeholders[1];
    },
    startValue: function startValue() {
      var innerValues = this.innerValues;

      var _innerValues = _slicedToArray(innerValues, 1),
          start = _innerValues[0]; // const [selectedStart] = selectedValue;
      // if (selectedStart) {
      //   start = selectedStart;
      // }


      return start;
    },
    endValue: function endValue() {
      var innerValues = this.innerValues;

      var _innerValues2 = _slicedToArray(innerValues, 2),
          end = _innerValues2[1]; // const [, selectedEnd] = selectedValue;
      // if (selectedEnd) {
      //   end = selectedEnd;
      // }


      return end;
    },
    enableBtn: function enableBtn() {
      var startValue = this.startValue,
          endValue = this.endValue;
      var next = addMonths(startValue, 1);
      return !isSameMonth(next, endValue);
    },
    disabledStartTime: function disabledStartTime() {
      var selectedValue = this.selectedValue,
          disabledTime = this.disabledTime;
      var disabledTimeConfig = disabledTime(selectedValue, 'start');
      return getTimeConfig(selectedValue, disabledTimeConfig);
    },
    disabledEndTime: function disabledEndTime() {
      var selectedValue = this.selectedValue,
          disabledTime = this.disabledTime;

      var _selectedValue = _slicedToArray(selectedValue, 2),
          start = _selectedValue[0],
          end = _selectedValue[1];

      var cfg = getTimeConfig(selectedValue, disabledTime(selectedValue, 'end')); //   结束时间和开始时间为同一天时, 结束时间的时分秒要在开始时间时分秒之后

      return genEndDisabledTime(start, end, cfg);
    },
    rangesIsArr: function rangesIsArr() {
      return Array.isArray(this.ranges);
    },
    isRanges: function isRanges() {
      var ranges = this.ranges,
          rangesIsArr = this.rangesIsArr;
      var ret = false;

      if (ranges) {
        if (rangesIsArr) {
          ret = ranges.length > 0;
        } else {
          ret = Object.keys(ranges).length > 0;
        }
      }

      return ret;
    },
    timeProps: function timeProps() {
      var showTime = this.showTime;

      if (_typeof(showTime) === 'object') {
        return showTime;
      }

      return {};
    },
    timeStartPickerProps: function timeStartPickerProps() {
      var prefixCls = this.prefixCls,
          timeProps = this.timeProps,
          selectedValue = this.selectedValue,
          _this$disabledStartTi = this.disabledStartTime,
          disabledHours = _this$disabledStartTi.disabledHours,
          disabledMinutes = _this$disabledStartTi.disabledMinutes,
          disabledSeconds = _this$disabledStartTi.disabledSeconds;
      return _objectSpread({
        showHour: true,
        showMinute: true,
        showSecond: true
      }, timeProps, {
        prefixCls: "".concat(prefixCls, "-time-picker"),
        value: selectedValue[0],
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds
      });
    },
    timeEndPickerProps: function timeEndPickerProps() {
      var prefixCls = this.prefixCls,
          timeProps = this.timeProps,
          selectedValue = this.selectedValue,
          _this$disabledEndTime = this.disabledEndTime,
          disabledHours = _this$disabledEndTime.disabledHours,
          disabledMinutes = _this$disabledEndTime.disabledMinutes,
          disabledSeconds = _this$disabledEndTime.disabledSeconds;
      return _objectSpread({
        showHour: true,
        showMinute: true,
        showSecond: true
      }, timeProps, {
        prefixCls: "".concat(prefixCls, "-time-picker"),
        value: selectedValue[1],
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds
      });
    }
  },
  watch: {
    value: function value(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerValues = this.normalizeAnchor();
      }
    },
    selectedValue: function selectedValue() {
      this.innerValues = this.normalizeAnchor();
    },
    mode: function mode(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerMode = nVal;
      }
    }
  },
  created: function created() {
    var mode = this.mode,
        normalizeAnchor = this.normalizeAnchor;
    this.innerMode = mode;
    this.innerValues = normalizeAnchor();
  },
  methods: {
    getValueFromSelectedValue: function getValueFromSelectedValue(selectedValue) {
      var _selectedValue2 = _slicedToArray(selectedValue, 2),
          start = _selectedValue2[0],
          end = _selectedValue2[1];

      var newEnd = end && isSameMonth(end, start) ? addMonths(end, 1) : end;
      return [start, newEnd];
    },
    normalizeAnchor: function normalizeAnchor() {
      var selectedValue = this.selectedValue,
          value = this.value,
          getValueFromSelectedValue = this.getValueFromSelectedValue,
          showTime = this.showTime;
      var normalizedValue = getValueFromSelectedValue(selectedValue);

      if (isValidArray(normalizedValue)) {
        return normalizedValue;
      }

      normalizedValue = getValueFromSelectedValue(value);

      if (isValidArray(normalizedValue)) {
        return normalizedValue;
      }

      var date = new Date(); // issue #166 如果设置了默认值且selected-value和value都没有的情况下，以默认值同步innerValue的时分秒

      if (isPlainObject(showTime) && isValidArray(showTime.defaultValue)) {
        var _showTime$defaultValu = _slicedToArray(showTime.defaultValue, 2),
            defaultStart = _showTime$defaultValu[0],
            defaultEnd = _showTime$defaultValu[1];

        return [syncTime(date, defaultStart), syncTime(addMonths(date, 1), defaultEnd)];
      }

      return [date, addMonths(date, 1)];
    },
    updateHoverValues: function updateHoverValues(values) {
      var hoverValues = cloneDeep(values);
      this.hoverValues = hoverValues;
      this.$emit('on-hover-change', hoverValues);
    },
    updateSelectedValues: function updateSelectedValues() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var updateHoverValues = this.updateHoverValues;

      var _values = _slicedToArray(values, 2),
          start = _values[0],
          end = _values[1];

      if (start && !end) {
        updateHoverValues(values);
      }

      this.$emit('calendar-change', values);

      if (!start && !end || start && end) {
        this.firstSelectedVal = null;
        updateHoverValues([]);
        this.$emit('on-select', values);
      }
    },
    disabledStartMonth: function disabledStartMonth(month) {
      var _this$innerValues2 = _slicedToArray(this.innerValues, 2),
          end = _this$innerValues2[1];

      var eVal = formatDate(end, 'YYYY-MM');
      var mVal = formatDate(month, 'YYYY-MM');
      return isAfter(mVal, eVal) || isEqual(mVal, eVal);
    },
    disabledEndMonth: function disabledEndMonth(month) {
      var _this$innerValues3 = _slicedToArray(this.innerValues, 1),
          start = _this$innerValues3[0];

      var sVal = formatDate(start, 'YYYY-MM');
      var mVal = formatDate(month, 'YYYY-MM');
      return isBefore(mVal, sVal) || isEqual(mVal, sVal);
    },
    isAllowedDateAndTime: function isAllowedDateAndTime(selectedValue) {
      var disabledDate = this.disabledDate,
          disabledStartTime = this.disabledStartTime,
          disabledEndTime = this.disabledEndTime,
          hasTimePicker = this.hasTimePicker;

      if (!hasTimePicker) {
        return isAllowedDate(selectedValue[0], disabledDate) && isAllowedDate(selectedValue[1], disabledDate);
      }

      return isAllowedDate(selectedValue[0], disabledDate, disabledStartTime) && isAllowedDate(selectedValue[1], disabledDate, disabledEndTime);
    },
    onDayHover: function onDayHover(value) {
      var firstSelectedVal = this.firstSelectedVal,
          updateHoverValues = this.updateHoverValues;

      if (firstSelectedVal) {
        var values = [firstSelectedVal];

        if (isBefore(value, firstSelectedVal)) {
          values.unshift(value);
        } else {
          values.push(value);
        }

        updateHoverValues(values);
      }
    },
    // 选择的时间与上一次选择的时间范围时间部分保持同步
    getSyncTime: function getSyncTime(values) {
      var selectedValue = this.selectedValue,
          innerValues = this.innerValues;
      return values.map(function (val, i) {
        // 上一次选择过有效范围的话会通过事件通知外部组件更新selectedValue
        // 如果selectedValue没有值，可能是还没有选择过,取innerValue
        var prevSelected = selectedValue[i] || innerValues[i];

        if (val && prevSelected) {
          return syncTime(val, prevSelected);
        }

        return val;
      });
    },
    onSelect: function onSelect(value) {
      var firstSelectedVal = this.firstSelectedVal,
          updateSelectedValues = this.updateSelectedValues,
          getSyncTime = this.getSyncTime;
      var values = [];

      if (!firstSelectedVal) {
        this.firstSelectedVal = value;
        values.push(value);
      } else if (isBefore(firstSelectedVal, value)) {
        values.push(firstSelectedVal, value);
      } else {
        values.push(value, firstSelectedVal);
      } // issue 165 166: 选择完范围后与上一次的选择同步时分秒


      updateSelectedValues(getSyncTime(values)); // updateSelectedValues(values);
    },
    onValueChange: function onValueChange(direction, value) {
      var innerValues = this.innerValues;
      this.innerValues = direction === 'left' ? [value, innerValues[1]] : [innerValues[0], value];
    },
    onStartPanelChange: function onStartPanelChange(value, next) {
      var controlMode = this.controlMode,
          innerMode = this.innerMode,
          innerValues = this.innerValues;
      var mode = [next, innerMode[1]];

      if (!controlMode) {
        this.innerMode = mode;
      }

      this.$emit('on-panel-change', [value || innerValues[0], innerValues[1]], mode);
    },
    onEndPanelChange: function onEndPanelChange(value, next) {
      var controlMode = this.controlMode,
          innerMode = this.innerMode,
          innerValues = this.innerValues;
      var mode = [innerMode[0], next];

      if (!controlMode) {
        this.innerMode = mode;
      }

      this.$emit('on-panel-change', [innerValues[0], value || innerValues[1]], mode);
    },
    onTimePickerChange: function onTimePickerChange(type, value) {
      var selectedValue = this.selectedValue;
      var values = cloneDeep(selectedValue);
      var idx = type === 'left' ? 0 : 1;
      values[idx] = value; // 防止结束时间小于开始时间

      if (isBefore(values[1], values[0])) {
        values[1 - idx] = values[idx];
      }

      this.updateSelectedValues(values);
    },
    onTodayClick: function onTodayClick() {
      var today = new Date();
      this.innerValues = [today, addMonths(today, 1)];
    },
    onTimePickerClick: function onTimePickerClick() {
      this.isTimePicker = !this.isTimePicker;
    },
    onOkClick: function onOkClick() {
      this.$emit('on-ok', this.selectedValue);
    },
    getRangeVal: function getRangeVal(range) {
      var val = range;

      if (typeof val === 'function') {
        val = val();
      }

      return val;
    },
    onRangeMouseEnter: function onRangeMouseEnter(range) {
      var getRangeVal = this.getRangeVal;
      var val = getRangeVal(range);

      if (Array.isArray(val)) {
        this.updateHoverValues(val);
      }
    },
    onRangeMouseLeave: function onRangeMouseLeave() {
      this.updateHoverValues([]);
    },
    onRangeClick: function onRangeClick(range, item) {
      var getRangeVal = this.getRangeVal;
      var val = getRangeVal(range);

      if (Array.isArray(val)) {
        if (val.every(function (v) {
          return v instanceof Date;
        })) {
          this.$emit('on-quick-select', val, item);
        }
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.prefixCls + "-panel"
  }, [_vm.isShowClear ? _c('a', {
    class: _vm.prefixCls + "-clear-btn",
    attrs: {
      "title": _vm.locale.clear,
      "role": "button"
    },
    on: {
      "click": _vm.clear
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-date-panel"
  }, [_c('calendar-part', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.startValue,
      "mode": _vm.innerMode[0],
      "selected-value": _vm.selectedValue,
      "hover-values": _vm.hoverValues,
      "locale": _vm.locale,
      "has-time-picker": _vm.hasTimePicker,
      "is-time-picker": _vm.isTimePicker,
      "format": _vm.format,
      "placeholder": _vm.startPlaceholder,
      "disabled-month": _vm.disabledStartMonth,
      "disabled-date": _vm.disabledDate,
      "disabled-time": _vm.disabledTime,
      "enable-next": _vm.enableBtn,
      "direction": "left",
      "enable-prev": ""
    },
    on: {
      "on-value-change": function onValueChange($event) {
        return _vm.onValueChange('left', $event);
      },
      "on-panel-change": _vm.onStartPanelChange,
      "on-day-hover": _vm.onDayHover,
      "on-select": _vm.onSelect
    }
  }, [_vm.hasTimePicker ? _c('time-picker-panel', _vm._b({
    attrs: {
      "slot": "timePicker"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.onTimePickerChange('left', $event);
      }
    },
    slot: "timePicker"
  }, 'time-picker-panel', _vm.timeStartPickerProps, false)) : _vm._e()], 1), _vm._v(" "), _c('span', {
    class: _vm.prefixCls + "-range-middle"
  }, [_vm._v("~")]), _vm._v(" "), _c('calendar-part', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "value": _vm.endValue,
      "mode": _vm.innerMode[1],
      "selected-value": _vm.selectedValue,
      "hover-values": _vm.hoverValues,
      "locale": _vm.locale,
      "has-time-picker": _vm.hasTimePicker,
      "is-time-picker": _vm.isTimePicker,
      "format": _vm.format,
      "placeholder": _vm.endPlaceholder,
      "disabled-month": _vm.disabledEndMonth,
      "disabled-date": _vm.disabledDate,
      "disabled-time": _vm.disabledTime,
      "enable-prev": _vm.enableBtn,
      "direction": "right",
      "enable-next": ""
    },
    on: {
      "on-value-change": function onValueChange($event) {
        return _vm.onValueChange('right', $event);
      },
      "on-panel-change": _vm.onEndPanelChange,
      "on-day-hover": _vm.onDayHover,
      "on-select": _vm.onSelect
    }
  }, [_vm.hasTimePicker ? _c('time-picker-panel', _vm._b({
    attrs: {
      "slot": "timePicker"
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.onTimePickerChange('right', $event);
      }
    },
    slot: "timePicker"
  }, 'time-picker-panel', _vm.timeEndPickerProps, false)) : _vm._e()], 1), _vm._v(" "), _vm.isRanges ? _c('div', {
    class: _vm.prefixCls + "-range-quick-selector"
  }, [_vm.rangesIsArr ? _vm._l(_vm.ranges, function (v, k) {
    return _c('div', {
      key: k,
      class: _vm.prefixCls + "-range-quick-selector-item",
      on: {
        "mouseenter": function mouseenter() {
          return _vm.onRangeMouseEnter(v.dates);
        },
        "mouseleave": _vm.onRangeMouseLeave,
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.onRangeClick(v.dates, v);
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(v.label))])]);
  }) : _vm._l(_vm.ranges, function (v, k) {
    return _c('div', {
      key: k,
      class: _vm.prefixCls + "-range-quick-selector-item",
      on: {
        "mouseenter": function mouseenter() {
          return _vm.onRangeMouseEnter(v);
        },
        "mouseleave": _vm.onRangeMouseLeave,
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.onRangeClick(v);
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(k))])]);
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: _vm.footerClasses
  }, [_vm.showToday || _vm.isShowOk ? _c('div', {
    class: _vm.prefixCls + "-footer-btn"
  }, [_vm.showToday ? _c('today-button', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "disabled": _vm.isTodayInView || _vm.isTimePicker,
      "disabled-date": _vm.disabledDate,
      "text": _vm.locale.backToToday,
      "has-time-picker": _vm.hasTimePicker,
      "is-show-ok": _vm.isShowOk,
      "format": _vm.format
    },
    on: {
      "on-click": _vm.onTodayClick
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasTimePicker ? _c('time-picker-button', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "disabled": _vm.isTimePickerDisabled,
      "is-time-picker": _vm.isTimePicker
    },
    on: {
      "on-click": _vm.onTimePickerClick
    }
  }) : _vm._e(), _vm._v(" "), _vm.isShowOk ? _c('ok-button', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "disabled": _vm.isOkDisabled
    },
    on: {
      "on-click": _vm.onOkClick
    }
  }) : _vm._e()], 1) : _vm._e()])])]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "rangeCalendar.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);